import { EditEmailTemplatePage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/email-template/$templateType/$subTemplate'].update({
        staticData: { title: { page: 'Email.Template.PageHeading' } },
        component: authGuard(EditEmailTemplatePage, { canManageEmailTemplates: true })
    });
};
